require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-uganda-investing-in-forests-and-protected-areas-for.json") })
        }
      }, "path---en-us-project-uganda-investing-in-forests-and-protected-areas-for");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-uganda-investing-in-forests-and-protected-areas-for!./.cache/json/en-us-project-uganda-investing-in-forests-and-protected-areas-for.json
// module id = 569
// module chunks = 231608221292675